import { useMemo } from "react";
import { useSelector } from "react-redux";
import { access as defaultAccess } from "constants/constants";
import { isEmpty } from "lodash";

const useAccess = () => {
  const {
    access,
    workspace_admin: admin,
    role,
    ...rest
  } = useSelector(state => ({
    ...state?.Profile?.me,
    // access: defaultAccess
  }));

  const _ = { get: () => new Proxy({}, _) };

  return useMemo(() => {
    if (admin || ["staff", "super admin", "participant"].includes(role)) {
      return new Proxy({}, _);
    } else {
      return isEmpty(access) ? defaultAccess : access;
    }
  }, [admin, access]);
};

export default useAccess;
